import { defineComponent, onMounted, ref, watch } from 'vue'
import { RouterLink } from 'vue-router'
import imgFansTitle from '@/assets/forum/fans-title.png'
import { getApiV1FansRanking } from '@/api/sdk.gen'

// 粉丝排行榜入口横幅：渲染 49208 同款 .fans-top
// 自行请求 /api/v1/fans-ranking，从 Top 149 列表中查 userId 对应排名
//
// 渲染策略：
//   - 默认（VITE_FORCE_SHOW_FANS_RANK 未设置）：作者未上榜时隐藏卡片，与 49208 一致
//   - VITE_FORCE_SHOW_FANS_RANK=true：始终显示卡片，未上榜时展示「暂未上榜」兜底文案
const FORCE_SHOW = import.meta.env.VITE_FORCE_SHOW_FANS_RANK === 'true'

export const FansTopBanner = defineComponent({
  name: 'FansTopBanner',
  props: {
    userId: { type: [Number, String], default: 0 },
  },
  setup(props) {
    const rank = ref(0)

    async function fetchRank() {
      const id = Number(props.userId)
      if (!id) {
        rank.value = 0
        return
      }
      try {
        const res = await getApiV1FansRanking()
        const list = res.data?.data?.list ?? []
        const item = list.find((i) => i.user_id === id)
        rank.value = item?.rank ?? 0
      } catch {
        rank.value = 0
      }
    }

    onMounted(fetchRank)
    watch(() => props.userId, fetchRank)

    return () => {
      if (rank.value <= 0 && !FORCE_SHOW) return null
      return (
        <div class="fans-top">
          <img class="title" src={imgFansTitle} alt="粉丝排行榜" />
          {rank.value > 0 ? (
            <span class="text">
              第<label>{rank.value}</label>名实力派高手
            </span>
          ) : (
            <span class="text">暂未上榜</span>
          )}
          <RouterLink class="more btn-reset" to="/top-fans-rank">
            查看更多 &gt;
          </RouterLink>
        </div>
      )
    }
  },
})

export default FansTopBanner
